
export interface tblToken {
  reDueDate: string;
  caseNumber: string;
  eliasCaseID: string;
  systemUniqueID: string;
  formLanguage: string;
  officialFormID: string;
  accessToken: string;
  refreshToken: string;
}

export class GenerateToken {
  tokenDetails: TokenDetails
}

export class InsertUserProfileCommand {
  userProfile: tblUserProfile
}

export class UpdateUserProfileCommand {
  userProfile: tblUserProfile
}

export class TokenDetails {
  userName: string;
  accountId: string;
} 

export class tblCoreUser {
  errorMessage: string;
  isError: boolean;
  userID: number;
  firstName: string;
  middleName: string;
  lastName: string;
  titleID: number;
  titleDesc: string;
  userTypeID: number;
  userTypeDesc: string;
  eaaid: string;
  email: string;
  saGeoKey: number;
  supervisorUserID: number;
  impersonationUserID: number;
  defaultLandingPage: string;
  inMaintenance: boolean;
  showIRSBanner: boolean;
  isSessionMismatched: boolean;
  storedSessionID: string;
  sessionUserID: number;
  primaryPhoneNumber: string;
  effectiveDate: any;
  effectiveEndDate: any;
  isActive: boolean;
  versionUserID: number;
  lanId: string;
  racfId: string;
  securityOverrideFlag: boolean;
}

export class UserRole {
  isAdmin: boolean;
}

export class tblUserProfile {
  userProfileID: number;
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  stateCode: string;
  city: string;
  zipCode: string;
  clientPreferredContactMethodID: number;
  clientEmailAddress: string;
  clientPhoneNumber: string;
  isActive: boolean;
  coreUserID: number;
  versionUserID: number;
  versionReason: string;
  versionTime: string;
  authId: string;
  accountId: string;
}

export interface UserProfileDetails {
  userProfile: tblUserProfile;
}
export interface ServiceResult<Type> {
  data: Type
}

export interface JWTRefreshToken {
  tokenString: string;
  expireAt: string;
}

export interface JWTRefreshTokenRequest {
  refreshToken: string;
}

export interface JWTRefreshTokenResponse {
  accessToken: string;
  refreshToken: JWTRefreshToken
}

